import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import PageMeta from "../../components/common/PageMeta";
import { useEffect, useState } from "react";
import Spinner from "../../components/ui/Spinner";
import {
    API_BASE_URL,
    API_URL,
    DEFAULT_PAGE_DESCRIPTION,
    DEFAULT_PAGE_TITLE,
} from "../../utilities/constants";
import { useParams } from "react-router";
import { handleApiCall } from "../../utilities/helper";

const DepartmentDetails = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [controller, setController] = useState(null);
    const { id } = useParams();
    console.log("data", data)

    // useEffect(() => {
    //     if (data) {
    //         setLoading(false);
    //     }
    // }, [data]);


    const callListByIdApi = async () => {
        controller?.abort();
        const newController = new AbortController();
        setController(newController);
        const { signal } = newController;
        setLoading(true);
        try {
            const response = await handleApiCall(
                `${API_BASE_URL}/api/1.0.0/department/${id}`,
                {
                    method: "GET"
                },
                null,
                signal
            );
            if (response.responseStatus == true) {
                setData(response.data);
            } else {
                setData(null);
            }
            if (response.responseCode !== 299) {
                setLoading(false);
            }
        } catch (e) {
            console.error("Error", e);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        callListByIdApi();
    }, [id]);


   return (
  <>
    <PageMeta
      title={`Department Details - ${DEFAULT_PAGE_TITLE}`}
      description={`Department Details - ${DEFAULT_PAGE_DESCRIPTION}`}
    />

    <div className="flex justify-between items-center mb-4">
       <PageBreadcrumb
          pageTitle="Department Details"
          breadcrumbs={[
            { label: "Department", path: "/department" },
            { label: "Department Details" }
          ]}
        />
    </div>

    {loading ? (
      <div className="flex justify-center items-center">
        <Spinner />
      </div>
    ) : (
      <div className="p-6 bg-white dark:bg-gray-800 rounded-lg shadow-md mx-auto h-full">
        <div className="flex flex-col md:flex-row gap-8">
          <div className="w-full md:w-1/3 space-y-6">
            <div className="p-4 rounded-lg bg-gray-50 dark:bg-gray-900 shadow-sm">
              <h3 className="text-sm text-gray-500 dark:text-gray-400">
                Department Name
              </h3>
              <p className="text-base font-medium text-gray-900 dark:text-gray-100">
                {data?.departmentName}
              </p>
            </div>

            <div className="p-4 rounded-lg bg-gray-50 dark:bg-gray-900 shadow-sm">
              <h3 className="text-sm text-gray-500 dark:text-gray-400">
                Department ID
              </h3>
              <p className="text-base font-medium text-gray-900 dark:text-gray-100">
                {data?.departmentId}
              </p>
            </div>

            <div className="p-4 rounded-lg bg-gray-50 dark:bg-gray-900 shadow-sm flex items-center gap-5">
              <h3 className="text-sm text-gray-500 dark:text-gray-400">
                Status
              </h3>
              <span
                className={`px-3 py-1 text-sm rounded-full font-medium ${
                  data?.status === 1
                    ? "bg-green-100 text-green-700 dark:bg-green-800 dark:text-green-100"
                    : "bg-red-100 text-red-700 dark:bg-red-800 dark:text-red-100"
                }`}
              >
                {data?.status === 1 ? "Active" : "Inactive"}
              </span>
            </div>
          </div>
               <div className="flex-1 md:pl-8 md:border-l border-gray-200 dark:border-gray-700 flex items-center justify-center">
                 {data?.additionalInfo ? (
                   <div className="space-y-4">
                     <div className="p-4 rounded-lg bg-gray-50 dark:bg-gray-900 shadow-sm">
                       <h3 className="text-sm text-gray-500 dark:text-gray-400">Description</h3>
                       <p className="text-base font-medium text-gray-900 dark:text-gray-100">
                         {data?.additionalInfo}
                       </p>
                     </div>
                   </div>
                 ) : (
                   <div className="text-center text-gray-500 dark:text-gray-400">
                     <svg
                       xmlns="http://www.w3.org/2000/svg"
                       className="mx-auto h-12 w-12 text-gray-400"
                       fill="none"
                       viewBox="0 0 24 24"
                       stroke="currentColor"
                     >
                       <path
                         strokeLinecap="round"
                         strokeLinejoin="round"
                         strokeWidth={2}
                         d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                       />
                     </svg>
                     <p className="mt-2">No additional details available for this department.</p>
                   </div>
                 )}
               </div>

        </div>
      </div>
    )}
  </>
);


}
export default DepartmentDetails;